<template>
  <div class="search">
    <div class="container mt-5">
      <div class="row">
        <h2 v-show="!hasKeyword">Search for a Product</h2>
        <h2 v-show="hasKeyword">
          Search Results for
          <span class="yellow-text text-uppercase">{{ keyword }}</span>
        </h2>
      </div>
      <div class="row search-form">
        <div class="col-lg-12">
          <form id="search-product">
            <div class="input-group py-3">
              <input
                id="productName"
                type="text"
                name="product"
                class="form-control"
                placeholder="Type a product keyword here"
                aria-describedby="inputGroupPrepend"
                v-model="keyword"
                @keyup="search"
              />
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-5" v-show="count > 0 && !searching">
        <div class="col-12">
          <span>About {{ count }} results found</span>
        </div>
      </div>
      <div class="row mt-5" v-if="searching">
        <div class="col-12 text-center">
          <i class="fas fa-spinner fa-spin fa-4x"></i>
        </div>
      </div>
    </div>
    <SearchResult :results="results" v-show="!searching"></SearchResult>
    <div class="row" v-show="nextPage !== null && !searching">
      <div class="col-12 text-center mt-5">
        <ul class="list-inline">
          <li class="list-inline-item">
            <button
              @click.prevent="search(previousPage)"
              class="btn btn-lg btn-dutche-violet"
              :disabled="previousPage == ''"
            >
              <i class="fa fa-arrow-left"></i> Previous
            </button>
          </li>
          <li class="list-inline-item">
            <button
              @click.prevent="search(nextPage)"
              class="btn btn-lg btn-dutche-violet"
              :disabled="nextPage == ''"
            >
              Next <i class="fa fa-arrow-right"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SearchResult from "@/components/search/SearchResult.vue";

export default {
  name: "Search",
  data() {
    return {
      keyword: null,
      results: undefined,
      count: 0,
      nextPage: null,
      previousPage: null,
      searching: false
    };
  },
  computed: {
    hasKeyword() {
      return this.keyword;
    },
  },
  components: {
    SearchResult,
  },
  methods: {
    search(page = 1) {
      let path = `/search/${this.keyword}`;
      if (page > 1) {
        path = `/search/${this.keyword}?page=${page}`;
      }

      if (this.keyword.length < 4) {
        return;
      }

      this.searching = true;

      axios.get(path).then((response) => {
        this.searching = false;
        this.count = response.data.count;
        this.results = response.data.results.data;
        this.nextPage =
          response.data.results.current_page !== response.data.results.last_page
            ? response.data.results.current_page + 1
            : '';
        this.previousPage =
          response.data.results.current_page !== 1
            ? response.data.results.current_page - 1
            : '';
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.search
  min-height: 500px
  height: auto

h2
  font-family: "Might Could"
h2>span
  font-family: "Gotham"
  font-size: 1.5rem
  color: $dutche-primary-yellow

.search-form
  background-color: $dutche-primary-violet
  min-height: 1.5rem
  border-radius: 1rem
  .form-control
    color: $white
    background-color: inherit
    border: none

  .form-control::placeholder
    color: $white
    text-transform: uppercase

    .input-group-text
      background-color: inherit
      border-top: none
      border-left: none
      border-right: none
      color: white
  
.btn-dutche-violet
  text-transform: uppercase
  border-radius: 15px
  background-color: $dutche-primary-violet
  color: $white
  padding: 0.5rem 1rem
  width: 180px

.fa-4x
  font-size: 4rem
</style>
